import { Controller } from "@hotwired/stimulus"
import { post } from "api"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "item"]
  static values = {
    handle: String,
    url: String,
  }

  connect() {
    new Sortable(this.listTarget, {
      ...(this.hasHandleValue ? { handle: this.handleValue } : {}),
      animation: 450,
      direction: "vertical",
      easing: "cubic-bezier(0, 1, 0, 1)",
      scroll: true,
      scrollSensitivity: 60,
      scrollSpeed: 12,
      dragClass: "bg-gray-400",
      ghostClass: "opacity-0",
      onEnd: async (detail) => {
        const event = new CustomEvent("onSortEnd", { detail })
        this.element.dispatchEvent(event)

        if (this.hasUrlValue) {
          const item_ids = this.itemTargets.map((el) => el.dataset.sortableItemId)
          const response = await post(
            this.urlValue,
            { item_ids },
            { Accept: "text/vnd.turbo-stream.html, text/html" }
          )
          if (
            response.ok &&
            response.contentType?.includes("text/vnd.turbo-stream.html") &&
            response.text
          ) {
            Turbo.renderStreamMessage(response.text)
          }
        }
      },
    })
  }
}
